let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("5v9Ee"), load("5VdYb"), load("6XyGC")]).then(() => parcelRequire('cV69w'));